import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api-client";
import { queryKeys } from "../lib/queryClient";
import { usePageMeta, useJsonLd, breadcrumbJsonLd } from "../lib/seo";
import { ErrorBanner, LoadingState } from "../components/States";
import { formatDateTime } from "../lib/format";

export function BlogListPage() {
  usePageMeta({
    title: "Blog",
    description:
      "Updates, announcements, and deep dives from MarketOnBase — on-chain protection for digital goods on Base.",
    path: "/blog",
  });

  useJsonLd(
    useMemo(
      () => breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }]),
      [],
    ),
  );

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.posts,
    queryFn: ({ signal }) => apiClient.getPosts({ limit: 30 }, signal),
  });

  return (
    <div className="stack" style={{ maxWidth: 720 }}>
      <div>
        <h1>Blog</h1>
        <p className="muted">Updates and announcements from MarketOnBase.</p>
      </div>

      {isLoading && <LoadingState label="Loading posts…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}

      {data && data.items.length === 0 && (
        <p className="muted">Nothing published yet — check back soon.</p>
      )}

      {data && data.items.length > 0 && (
        <div className="stack">
          {data.items.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="card stack"
              style={{ gap: "0.4rem", textDecoration: "none", color: "inherit" }}
            >
              <span className="muted text-sm">
                {post.publishedAt ? formatDateTime(post.publishedAt) : ""}
              </span>
              <h2 style={{ margin: 0 }}>{post.title}</h2>
              {post.excerpt && (
                <p className="muted" style={{ margin: 0 }}>
                  {post.excerpt}
                </p>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
